var map = {
	"./2012.png": 86,
	"./2013.png": 87,
	"./2014.png": 88,
	"./2015.png": 89,
	"./2016.png": 90,
	"./2017.png": 91,
	"./2018.png": 92,
	"./2019.png": 93,
	"./2020.png": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;